import { Injectable } from '@angular/core';
import { ScreenSize } from '../enums/screen-size.enum';

@Injectable({
    providedIn: 'root'
})
export class LayoutService {
    private screenSize = ScreenSize.SM;
    private heightSize = ScreenSize.HBP1;
    private resizeHandler: () => void;

    constructor() {
        // Creăm o referință la funcție pentru a putea elimina event listener-ul corect
        this.resizeHandler = () => this.setScreenSize();

        window.addEventListener('resize', this.resizeHandler);
        this.setScreenSize();
    }

    private setScreenSize() {
        // Resetăm la valoarea minimă
        this.screenSize = ScreenSize.BP;

        // Verificăm WIDTH și setăm screenSize
        if (innerWidth >= ScreenSize.XL) {
            this.screenSize = ScreenSize.XL;
        } else if (innerWidth >= ScreenSize.LG) {
            this.screenSize = ScreenSize.LG;
        } else if (innerWidth >= ScreenSize.MD) {
            this.screenSize = ScreenSize.MD;
        } else if (innerWidth >= ScreenSize.SM) {
            this.screenSize = ScreenSize.SM;
        } else if (innerWidth >= ScreenSize.BP) {
            this.screenSize = ScreenSize.XS;
        } else {
            this.screenSize = ScreenSize.BP;
        }

        // Verificăm HEIGHT și setăm heightSize (separat!)
        if (innerHeight >= ScreenSize.HBP1) {
            this.heightSize = ScreenSize.HBP1;
        } else {
            this.heightSize = ScreenSize.BP; // sau altă valoare default
        }
    }

    getScreenSize() {
        if (this.isBP()) return 'bp';
        if (this.isXS()) return 'xs';
        if (this.isSM()) return 'sm';
        if (this.isMD()) return 'md';
        if (this.isLG()) return 'lg';
        if (this.isXL()) return 'xl';
        return 'xs';
    }

    isBP() {
        return this.screenSize === ScreenSize.BP;
    }

    isXS() {
        return this.screenSize === ScreenSize.XS;
    }

    isSM() {
        return this.screenSize === ScreenSize.SM;
    }

    isMD() {
        return this.screenSize === ScreenSize.MD;
    }

    isLG() {
        return this.screenSize === ScreenSize.LG;
    }

    isXL() {
        return this.screenSize === ScreenSize.XL;
    }

    isHBP1() {
        return this.heightSize === ScreenSize.HBP1;
    }

    // Metodă pentru cleanup dacă este necesar
    ngOnDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
    }
}